import { FC } from 'react';
import Chess from './Chess';
import RoboArm from './Roboarm';
import Chart from './Chart';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { productName } = ApplicationDomainUtility;
import Puzzle from './Puzzle';

const Cards: FC<{ type: string }> = ({ type }) => {
  switch (type) {
    case 'chess':
      return <Chess productName={productName} />;
    case 'puzzle':
      return <Puzzle />;
    case 'roboArm':
      return <RoboArm productName={productName} />;
    case 'chart':
      return <Chart productName={productName} />;
    default:
      return <></>;
  }
};

export default Cards;
